import {GenericModel} from '../../shared/model/generic.model';

export class Resultado extends GenericModel {
    
    public nome: string;
    public mensagem: string;

}
